import { useStandardRole } from "./useStandardRole";
/**
 * Hook to determine phone number visibility permissions
 * - Admins: See full phone numbers without needing to unmask
 * - Staff (non-consultants): See masked numbers, can unmask with audit logging
 * - Consultants: Cannot see phone numbers at all
 */
export const useCanViewPhoneNumbers = () => {
  const { data: standardRole, isLoading } = useStandardRole();
  
  // SECURITY: ALL users see masked numbers and must unmask (with audit logging)
  // This ensures phone number access is always tracked in the audit trail
  const canViewFullPhoneNumbers = false;
  
  // Only block phone numbers for true external consultants (not associate dentists with clinical access)
  const isConsultantOnly = standardRole?.isDoctor && !standardRole?.isOwner && !standardRole?.isDoctor && !standardRole?.isManager && !standardRole?.isOwner;
  
  // Everyone except true external consultants can unmask (with logging)
  const canUnmaskPhoneNumbers = !isConsultantOnly;
  
  // Legacy support - shows phone section for non-consultants
  const canViewPhoneNumbers = !isConsultantOnly;
  
  return { 
    canViewFullPhoneNumbers,
    canUnmaskPhoneNumbers,
    canViewPhoneNumbers,
    isConsultantOnly,
    isLoading
  };
};
